var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "Information",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <g id="svg-fg">
    <path d="M32,21a2.24,2.24,0,1,1,1.59-.66A2.23,2.23,0,0,1,32,21Z"/>
    <path d="M32,17a1.74,1.74,0,1,1-1.23.51A1.73,1.73,0,0,1,32,17m0-1a2.74,2.74,0,1,0,1.94.8A2.73,2.73,0,0,0,32,16Z"/>
    <path d="M32,47.5a2.2,2.2,0,0,1-2.19-2.19V28.2a2.19,2.19,0,0,1,4.39,0v17.1A2.2,2.2,0,0,1,32,47.5Z"/>
    <path d="M32,26.51A1.7,1.7,0,0,1,33.7,28.2v17.1a1.69,1.69,0,0,1-3.39,0V28.2A1.7,1.7,0,0,1,32,26.51m0-1a2.7,2.7,0,0,0-2.69,2.69v17.1a2.69,2.69,0,0,0,5.39,0V28.2A2.7,2.7,0,0,0,32,25.51Z"/>
  </g>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/app/assets/icons/information.svg